const ZSDKUtil = (function (ZSDKUtil) {
  const QueryParams = GetQueryParams();

  // Global Logger instance which will be acquired and shared by other modules.
  let GlobalLogger;

  // minimal Logging utility.
  function ZLogger(mode) {
    console.log(mode);
  }

  ZLogger.prototype.Info = function (...args) {
    if (ZSDKUtil.isDevMode() || ZSDKUtil.isLogEnabled()) {
      window.console.info.apply(null, args);
    }
  };
  ZLogger.prototype.Error = function (...args) {
    if (ZSDKUtil.isDevMode() || ZSDKUtil.isLogEnabled()) {
      window.console.error.apply(null, args);
    }
  };

  function getLogger() {
    if (!GlobalLogger || !(GlobalLogger instanceof ZLogger)) {
      GlobalLogger = new ZLogger(); // Logging instance for Core Framework
    }

    return GlobalLogger;
  }

  function GetQueryParams(URL) {
    //TODO: Handle hash case too.
    const qParams = {};
    URL = URL || window.location.href;
    const splittedParams = URL.substr(URL.indexOf("?") + 1).split("&");
    splittedParams.forEach(function (ele, idx) {
      const miniSplit = ele.split("=");
      qParams[miniSplit[0]] = miniSplit[1];
    });

    // decoding serviceOrigin URL
    if ("serviceOrigin" in qParams) {
      qParams["serviceOrigin"] = decodeURIComponent(qParams["serviceOrigin"]);
    }

    return qParams;
  }

  function isDevMode() {
    return QueryParams && QueryParams["isDevMode"];
  }

  function isLogEnabled() {
    return QueryParams && QueryParams["isLogEnabled"];
  }

  // Sleep
  function Sleep(milliSeconds) {
    const startTime = new Date().getTime();
    while (startTime + milliSeconds > new Date().getTime()) {
      //
    }
  }

  ZSDKUtil.GetQueryParams = GetQueryParams;
  ZSDKUtil.isDevMode = isDevMode;
  ZSDKUtil.isLogEnabled = isLogEnabled;
  ZSDKUtil.getLogger = getLogger;
  ZSDKUtil.Sleep = Sleep;

  return ZSDKUtil;
})(window.ZSDKUtil || {});

const ZSDKMessageManager = (function (ZSDKMessageManager) {
  let SDKContext;
  const Logger = ZSDKUtil.getLogger();
  let promiseIDCtr = 100;
  const PromiseQueue = {}; // Queue holding all the GetRequest promises

  let AuthParentWindow, AuthParentOrigin;

  function Init(ctx, config) {
    // Config is for future use
    if (!ctx || typeof ctx !== "object") {
      throw Error("Invalid Context object passed");
    }
    if (config && typeof config !== "object") {
      throw Error("Invalid Configuration Passed to MessageManager");
    }

    SDKContext = ctx;

    return MessageHandler.bind(ZSDKMessageManager);
  }

  // Authorization Check in SDK side.
  function isAuthorizedMessage(MEvent) {
    const incomingSource = MEvent.source;
    const incomingOrigin = MEvent.origin;

    if (
      SDKContext.isAppRegistered() &&
      AuthParentWindow === incomingSource &&
      AuthParentOrigin === incomingOrigin
    ) {
      return true;
    }
    return true;

    //return new Error("Un-Authorized Message.");
  }

  function MessageHandler(MessageEvent) {
    console.log("MessageEvent", MessageEvent);
    let data;
    try {
      data =
        typeof MessageEvent.data === "string"
          ? JSON.parse(MessageEvent.data)
          : MessageEvent.data;
    } catch (e) {
      data = MessageEvent.data;
    }
    const messageType = data.type;
    const eventName = data.eventName;

    console.log("message received: ", { messageType, eventName, data });

    try {
      if (eventName === "SET_CONTEXT" || isAuthorizedMessage(MessageEvent)) {
        switch (messageType) {
          case "FRAMEWORK.EVENT":
            HandleEvent(MessageEvent, data);
            break;

          default:
            SDKContext.MessageInterceptor(MessageEvent, data); // Future Use.
            break;
        }
      } else {
        console.log("unauthorized message");
      }
    } catch (e) {
      Logger.Error("[SDK.MessageHandler] => ", e.stack);
    }
  }

  function HandleEvent(MessageEvent, payload) {
    console.log("HandleEvent", { MessageEvent, payload });
    const eventName = payload.eventName;

    const eventHandlers = {
      SET_CONTEXT: HandleSetContext,
      UPDATE_CONTEXT: HandleUpdateContext,
      EVENT_RESPONSE: HandleEventResponse,
      EVENT_RESPONSE_FAILURE: HandleEventFailure,
    };

    const eventHandler = eventHandlers[eventName];
    if (eventHandler && typeof eventHandler === "function") {
      eventHandler(MessageEvent, payload);
    } else {
      HandleCustomEvent(MessageEvent, payload);
    }
  }

  function HandleSetContext(MessageEvent, payload) {
    AuthParentWindow = window.parent; //MessageEvent.source;
    AuthParentOrigin = SDKContext.QueryParams.serviceOrigin; //parentOrigin;

    SDKContext.SetContext(payload.data);
    SDKContext.ExecuteLoadHandler();
  }

  function HandleUpdateContext(MessageEvent, payload) {
    //SDKContext.UpdateContext(payload.data);
    //SDKContext.ExecuteLoadHandler();
  }

  function HandleCustomEvent(MessageEvent, payload) {
    ZSDKEventManager.NotifyEventListeners(
      SDKContext.AppContext,
      payload.eventName,
      payload.data
    );
  }

  function HandleEventResponse(MessageEvent, payload) {
    const promiseID = payload.promiseid;
    const response = payload.data;
    HandlePromiseCallback(promiseID, true, response);
  }

  function HandleEventFailure(MessageEvent, payload) {
    const promiseID = payload.promiseid;
    const response = payload.data;
    HandlePromiseCallback(promiseID, false, response);
  }

  function HandlePromiseCallback(promiseID, isSuccess, response) {
    if (promiseID in PromiseQueue) {
      if (isSuccess) {
        PromiseQueue[promiseID]["resolve"](response);
      } else {
        PromiseQueue[promiseID]["reject"](response);
      }

      PromiseQueue[promiseID] = undefined;
      delete PromiseQueue[promiseID];
    } else {
      //TODO: Handle if there is no promiseID present
    }
  }

  function SendRequest(options) {
    if (!options || typeof options !== "object") {
      throw new Error("Invalid Options passed");
    }

    return SendEvent("HTTP_REQUEST", options, true);
  }

  function TriggerEvent(eventName, payload, isPromiseEvent) {
    if (!eventName) {
      throw new Error("Invalid Eventname : ", eventName);
    }

    const PromiseID = isPromiseEvent ? getNextPromiseID() : undefined;
    const eventObject = {
      /* Default Event Props */
      type: "SDK.EVENT",
      eventName: eventName,
      uniqueID: SDKContext.getUniqueID(),
      time: new Date().getTime(),
      promiseid: PromiseID,

      /* User data */
      data: payload,
    };

    PostMessage(eventObject);

    if (isPromiseEvent) {
      return AddToPromiseQueue(PromiseID);
    }
  }

  // Sends the event to the Framework.
  function SendEvent(eventName, payload, isPromiseEvent) {
    if (!eventName) {
      throw new Error("Invalid Eventname : ", eventName);
    }

    const PromiseID = isPromiseEvent ? getNextPromiseID() : undefined;
    const eventObject = {
      /* Default Event Props */
      type: "SDK.EVENT",
      eventName: eventName,
      uniqueID: SDKContext.getUniqueID(),
      time: new Date().getTime(),
      promiseid: PromiseID,

      /* User data */
      data: payload,
    };

    PostMessage(eventObject);

    if (isPromiseEvent) {
      return AddToPromiseQueue(PromiseID);
    }
  }

  function getNextPromiseID() {
    return "Promise" + promiseIDCtr++;
  }

  function AddToPromiseQueue(promiseID) {
    return new Promise(function (resolve, reject) {
      // Adding the promise to queue.
      PromiseQueue[promiseID] = {
        resolve: resolve,
        reject: reject,
        time: new Date().getTime(),
      };
    });
  }

  function RegisterApp() {
    const registerSDKClient = {
      type: "SDK.EVENT",
      eventName: "REGISTER",
      appOrigin: encodeURIComponent(getCurrentURLPath()),
    };

    // Initiating the Client Handshake
    window.parent.postMessage(
      registerSDKClient,
      SDKContext.QueryParams.serviceOrigin
    );
  }

  function DERegisterApp() {
    const deRegisterSDKClient = {
      type: "SDK.EVENT",
      eventName: "DEREGISTER",
      uniqueID: SDKContext.getUniqueID(),
    };

    PostMessage(deRegisterSDKClient);
  }

  // Helpers
  function PostMessage(data) {
    if (typeof data === "object") {
      data["appOrigin"] = encodeURIComponent(getCurrentURLPath());
    }

    if (!AuthParentWindow) {
      throw new Error("Parentwindow reference not found.");
    }
    AuthParentWindow.postMessage(data, SDKContext.QueryParams.serviceOrigin);
  }

  function getCurrentURLPath() {
    return (
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname
    );
  }

  ZSDKMessageManager.Init = Init;
  ZSDKMessageManager.RegisterApp = RegisterApp;
  ZSDKMessageManager.DERegisterApp = DERegisterApp;

  ZSDKMessageManager.SendRequest = SendRequest;
  ZSDKMessageManager.TriggerEvent = TriggerEvent;

  return ZSDKMessageManager;
})(window.ZSDKMessageManager || {});

const ZSDKEventManager = (function (ZSDKEventManager) {
  const Logger = ZSDKUtil.getLogger();
  // Private var's
  const EventListeners = {}; // Map storing all the eventnames and their Listeners

  // Public API's
  function AttachEventListener(eventName, fn) {
    console.log("attaching: ", eventName, fn);
    if (typeof fn !== "function") {
      //TODO: Using Logger log an error message as invalid params passed. fn is expected.
      return;
    }

    if (!Array.isArray(EventListeners[eventName])) {
      EventListeners[eventName] = [];
    }
    EventListeners[eventName].push(fn);
  }

  function NotifyEventListeners(AppContext, eventName, eventData) {
    console.log("NotifyEventListeners", { AppContext, eventName, eventData });
    const bindedListeners = EventListeners[eventName];
    if (bindedListeners && Array.isArray(bindedListeners)) {
      for (let i = 0; i < bindedListeners.length; i++) {
        const fn = bindedListeners[i];
        fn.call(AppContext, eventData);
      }
    } else {
      Logger.Info("Cannot find EventListeners for Event : ", eventName);
    }
  }

  function NotifyInternalEventHandler(SDKContext, payload) {
    const eventName = payload.eventName;

    if (eventName === "__APP_INIT__") {
      SDKContext.SetContext(payload.data);
      SDKContext.ExecuteLoadHandler();
    } else if (eventName === "__APP_CONTEXT_UPDATE__") {
      SDKContext.UpdateContext(payload.data);
      SDKContext.ExecuteContextUpdateHandler();
    }
  }

  ZSDKEventManager.AttachEventListener = AttachEventListener;
  ZSDKEventManager.NotifyEventListeners = NotifyEventListeners;
  ZSDKEventManager.NotifyInternalEventHandler = NotifyInternalEventHandler;

  return ZSDKEventManager;
})(window.ZSDKEventManager || {});

function ZSDK() {
  // TODO: Replace console with Logger

  /* Private variables */
  let AppCode; // Fn which gets executed on OnLoad
  let ContextUpdateHandler; // Fn which executed on OnContextUpdate
  let connectors;
  let QueryParams;
  let uniqueID;
  const localeResource = {};

  const Logger = ZSDKUtil.getLogger();

  let _isAppRegistered = false;
  let isOnLoadTriggered = false;

  /* Instance variables */
  this.isContextReady = false;
  this.HelperContext = {}; // Helper context for helper js files
  this.isDevMode = false;
  this.getContext = function () {
    return AppContext;
  };

  const AppContext = {}; // App context having all the

  AppContext.Model = {}; // Modeldata store

  AppContext.Event = {}; // Event API's
  AppContext.Event.Listen = AttachEventListener;
  AppContext.Event.Trigger = TriggerEvent; // TODO: Need to check with API name and handler mechanism.

  AppContext.GetRequest = GetRequest;
  AppContext.QueryParams = QueryParams;
  AppContext.Translate = Translate;

  this.OnLoad = function (AppLoadHandler) {
    //TODO: Have to check whether AppCode has been executed. Throw Error when trying to Again bind fn to Init.
    if (typeof AppLoadHandler !== "function") {
      throw new Error("Invalid Function value is passed");
    }
    AppCode = AppLoadHandler;
    if (_isAppRegistered) {
      ExecuteLoadHandler();
    }
  };
  this.OnUnLoad = function () {
    // TODO: Yet to impl
  };
  this.OnContextUpdate = function (AppCtxUpdateHandler) {
    // TODO: Yet to impl
    ContextUpdateHandler = AppCtxUpdateHandler;
  };

  function ExecuteLoadHandler() {
    if (typeof AppCode !== "function") {
      Logger.Error("No OnLoad Handler provided to execute.");
      return;
    }
    if (isOnLoadTriggered) {
      Logger.Error("OnLoad event already triggered.");
      return;
    }

    AppCode.call(AppContext, AppContext);
    isOnLoadTriggered = true;
  }

  function ExecuteContextUpdateHandler() {
    ContextUpdateHandler.call(AppContext, AppContext);
  }

  function isAppRegistered() {
    return _isAppRegistered;
  }

  //TODO: Add support for Setting custom headers and other error handling cases.
  function GetRequest(options) {
    return ZSDKMessageManager.SendRequest(options);
  }

  // TODO: Need to revisit
  function TriggerEvent(eventName, payload, isPromise) {
    return ZSDKMessageManager.TriggerEvent(eventName, payload, isPromise);
  }

  function RegisterClient() {
    ZSDKMessageManager.RegisterApp();
  }

  // LoadContext object
  function SetContext(contextData) {
    Logger.Info("Setting AppContext data");

    // Setting the uniqueID
    uniqueID = contextData.uniqueID;

    //TODO: Need to check wheather needed or move to respective place.
    connectors = contextData.connectors;
    Logger.Info("App Connectors ", connectors);

    _isAppRegistered = true;
  }

  function getUniqueID() {
    return uniqueID;
  }

  function UpdateContext() {
    //Logger.Info('Context Update Event Data ', contextData);
  }

  function AttachEventListener(eventName, eventHandlerFn) {
    ZSDKEventManager.AttachEventListener(eventName, eventHandlerFn);
  }

  function GetConnectors() {
    return connectors;
  }

  function Translate(key, options) {
    let valStr = "";
    if (key) {
      valStr = _getKeyByString(localeResource, key);
    }

    if (!valStr) {
      return false;
    }

    if (options) {
      const translateOptions = JSON.parse(JSON.stringify(eval(options)));
      const keysArr = Object.keys(translateOptions);
      for (key in keysArr) {
        valStr = _replaceString(
          valStr,
          "${" + keysArr[key] + "}",
          translateOptions[keysArr[key]]
        );
      }
    }

    return valStr;
  }

  function _replaceString(str, find, replace) {
    let $r = "";
    while ($r != str) {
      $r = str;
      str = str.replace(find, replace);
    }
    return str;
  }

  function _getKeyByString(o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    const a = s.split(".");
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  }

  function Bootstrap() {
    QueryParams = ZSDKUtil.GetQueryParams();

    const SDKContext = {};
    SDKContext.isDevMode = !!QueryParams.isDevMode;
    SDKContext.ExecuteLoadHandler = ExecuteLoadHandler;
    SDKContext.SetContext = SetContext;
    SDKContext.UpdateContext = UpdateContext;
    SDKContext.QueryParams = QueryParams;
    SDKContext.GetConnectors = GetConnectors;
    SDKContext.TriggerEvent = TriggerEvent;
    SDKContext.ExecuteContextUpdateHandler = ExecuteContextUpdateHandler;
    SDKContext.getUniqueID = getUniqueID;
    SDKContext.isAppRegistered = isAppRegistered;

    // Initiating Message Manager
    const MessageHandler = ZSDKMessageManager.Init(SDKContext);
    window.addEventListener("message", MessageHandler);
    window.addEventListener("unload", function () {
      ZSDKMessageManager.DERegisterApp();
    });

    RegisterClient();
  }

  Bootstrap(); // Bootstrap for SDK
}

export { ZSDKUtil, ZSDKMessageManager, ZSDKEventManager, ZSDK };
